import validationRun from "@/store/modules/ordersOverview/validationRun";
import orderService from "@/services/OrderService";
import {tableMutations} from "@tt/vue-components";

const order = {
  namespaced: true,
  state: {
    loading: false,
    item: null,
    validationRuns: [],
    rma: null
  },
  modules: {
    validationRun
  },
  mutations: {
    ...tableMutations,
    SET_VIEW(state, view) {
      state.view = view;
    },
    SET_VALIDATION_RUNS(state, validationRuns) {
      state.validationRuns = validationRuns;
    },
    SET_RMA(state, rma) {
        state.rma = rma;
    }
  },
  actions: {
      fetchOrder(context, orderId) {
          orderService.orders.get(orderId)
              .then(json => {
                  context.commit("SET_ITEM", json);
              })
              .catch(err => {
                  console.log(err);
              })
              .finally(() => {
                  context.commit("SET_LOADING", false);
              });
      },
      refreshOrder(context) {
          if (context.state.item !== null) {
              context.dispatch("fetchOrder", context.state.item.id);
          }
      },
      patch({commit, dispatch}, order) {
          return new Promise((resolve, reject) => {
              orderService.orders.patch(order.id, order.body)
                  .then((order) => {
                      commit("SET_ITEM", order);
                      dispatch("ordersOverview/updateItem", order, {root: true})
                      resolve();
                  })
                  .catch(err => {
                      reject(err["hydra:description"]);
                  });
          });
      },
      patchOrderLines({commit, state}, orderLine) {
          return new Promise((resolve, reject) => {
              orderService.orderItems.patch(orderLine.id, orderLine.body)
                  .then((response) => {
                      let order = {...state.item}
                      order.orderItems.map((item) => {
                          if (item.id === response.id) {
                              item.locked = response.locked
                          }
                      })
                      commit("SET_ITEM", order);
                      resolve();
                  })
                  .catch(err => {
                      console.log(err);
                      reject(err["hydra:description"]);
                  });
          });
      },
      orderCancel({dispatch, state}, orderCancel) {
          return new Promise((resolve, reject) => {
              orderService.orderCancels.create(orderCancel)
                  .then(() => {
                      dispatch('fetchOrder', state.item.id)
                      dispatch("ordersOverview/selectItem", state.item, {root: true})
                      resolve();
                  })
                  .catch(err => {
                      reject(err["hydra:description"]);
                  });
          });
      },
      orderReturn({dispatch, state}, orderReturn) {
          return new Promise((resolve, reject) => {
              orderService.orderReturns.create(orderReturn)
                  .then(() => {
                      dispatch('fetchOrder', state.item.id)
                      dispatch("ordersOverview/selectItem", state.item, {root: true})
                      resolve();
                  })
                  .catch(err => {
                      reject(err["hydra:description"]);
                  });
          });
      },
      suborder({dispatch, state}, order) {
          return new Promise((resolve, reject) => {
              orderService.suborder.create(order)
                  .then(() => {
                      dispatch('fetchOrder', state.item.id)
                      dispatch("ordersOverview/selectItem", state.item, {root: true})
                      resolve();
                  })
                  .catch(err => {
                      reject(err["hydra:description"]);
                  });
          });
      },
      fetchRma({commit}, orderId) {
          return new Promise((resolve, reject) => {
              orderService.rma.get(orderId)
                  .then((response) => {
                      commit("SET_RMA", response.items?.[0] ?? null);
                      resolve();
                  })
                  .catch(err => {
                      console.log(err);
                      reject(err["hydra:description"]);
                  });
          });
      }
  }
};

export default order;
